import React from 'react'
import { Box, Typography, Button, Divider } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

interface GoogleRatingInfoProps {
  rating?: number | null
  reviewCount?: number | null
  placeId?: string | null
  updatedAt?: string | null
}

// Read-only display of Google Places data (synced by pipeline, not editable here)
export default function GoogleRatingInfo({ rating, reviewCount, placeId, updatedAt }: GoogleRatingInfoProps) {
  if (rating == null && !placeId) return null

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        Google rating
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Synkroniseres automatisk fra Google Places og kan ikke redigeres her.
        Vises på sitet hvis der ikke er en Trustpilot-rating.
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <StarIcon sx={{ color: '#fbbc04' }} />
          <Typography variant="h6" fontWeight={600}>
            {rating != null ? Number(rating).toFixed(1) : '–'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ({reviewCount ?? 0} anmeldelser)
          </Typography>
        </Box>
        {updatedAt && (
          <Typography variant="body2" color="text.secondary">
            Opdateret: {new Date(updatedAt).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' })}
          </Typography>
        )}
        {placeId && (
          <Button
            size="small"
            variant="outlined"
            endIcon={<OpenInNewIcon />}
            href={`https://www.google.com/maps/place/?q=place_id:${placeId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Åbn i Google Maps
          </Button>
        )}
      </Box>
      {placeId && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          Place ID: {placeId}
        </Typography>
      )}
    </Box>
  )
}
